import * as React from 'react';
import {
    ButtonGroup,
    ClickAwayListener, Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper,
} from "@mui/material";
import {ArrowDropDown, CreateNewFolder, GridView, ListSharp, MoreVertOutlined} from "@mui/icons-material";
import Button from "@mui/material/Button";
import useDrive from "../../hooks/useDrive";
import {LAYOUTS} from "../../config/appConst";
import styles from "../DriveRow/drive-row.module.css";

export function LayoutSwitch(props) {

    const {layout, changeLayout} = useDrive();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(1);

    const handleClick = () => {
        console.info(`You clicked ${selectedIndex}`);
    };

    const handleMenuItemClick = layout => {
        changeLayout(layout)
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const loadLayoutIcon = () => {
        switch (layout) {
            case LAYOUTS.LIST:
                return <ListSharp fontSize={"small"}/>;
            case LAYOUTS.GRID:
                return <GridView fontSize={"small"}/>;
            default:
                return <GridView fontSize={"small"}/>;

        }
    }
    return (
        <>
            <React.Fragment>
                <ButtonGroup variant="contained" ref={anchorRef} aria-label="Layout switch">
                    <Button
                        size="small"
                        style={{
                            width: "45px",
                            height: "45px",
                            backgroundColor: "#8c3b61",
                            borderTopRightRadius: "0",
                            borderBottomRightRadius: "0",
                            borderRight: "1px solid #bdbdbd",
                            borderColor: "#985373"
                        }} onClick={handleClick}>{loadLayoutIcon()}</Button>
                    <Button
                        style={{width: "45px", height: "45px", backgroundColor: "#8c3b61"}}
                        size="small"
                        aria-controls={open ? 'split-button-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-label="select merge strategy"
                        aria-haspopup="menu"
                        onClick={handleToggle}
                    >
                        <ArrowDropDown/>
                    </Button>
                </ButtonGroup>
                <Popper
                    sx={{
                        zIndex: 1,
                    }}
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    transition
                    disablePortal
                >
                    {({TransitionProps, placement}) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom' ? 'center top' : 'center bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList id="split-button-menu" autoFocusItem>
                                        {Object.values(LAYOUTS).map((l, index) => (
                                            <MenuItem
                                                className={styles.optionMenuItem}
                                                key={l}
                                                disabled={l === layout}
                                                onClick={() => handleMenuItemClick(l)}
                                            >
                                                {l}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </React.Fragment>

            {/*<ButtonGroup aria-label="split button">*/}

            {/*    <Avatar variant={"rounded"} style={{width: "45px", height: "45px", backgroundColor: "#8c3b61"}}>*/}

            {/*        <Tooltip title="Upload files">*/}
            {/*        <IconButton*/}
            {/*            component="span" style={{color: "#fff"}}*/}
            {/*            size="small"*/}
            {/*            aria-controls={open ? 'split-button-menu' : undefined}*/}
            {/*            aria-expanded={open ? 'true' : undefined}*/}
            {/*            aria-label="Actions"*/}
            {/*            aria-haspopup="menu"*/}
            {/*            onClick={handleToggle}*/}
            {/*        >*/}
            {/*            {loadLayoutIcon()}*/}
            {/*            <ArrowDropDown fontSize={"small"}/>*/}
            {/*        </IconButton>*/}
            {/*        </Tooltip>*/}
            {/*    </Avatar>*/}
            {/*</ButtonGroup>*/}

            {/*<span ref={anchorRef}/>*/}

        </>

    );
};